import { gql } from '@ori/fetching';

const subscriptionBenefitBanner = gql`
  fragment SubscriptionBenefitBanner on Product {
    subscriptionBenefitBanner {
      title
      message
      registerLink {
        title
        relativeUrl
      }
      readMoreLink {
        title
        relativeUrl
      }
      signInLink {
        title
        relativeUrl
      }
    }
  }
`;

const shade = gql`
  ${subscriptionBenefitBanner}
  fragment Shade on Product {
    ...SubscriptionBenefitBanner
    availability {
      isBackorder
    }
    backInStockAvailability {
      showBackInStockNotification
    }
    color
    colorHexCode
    colorImageUrl
    formattedPrice {
      bp
      price {
        basicCashback
        basicCataloguePrice
        currentPrice
        previousMinOfferPrice
        sharingBonus
      }
    }
    isDiscontinued
    imageUrl
    labels {
      helpText
      labelKey
      productLabelDomain
      title
    }
    pdpUrl {
      relativeUrl
    }
    productCode
    volume
    volumeUnit
  }
`;

const concept = gql`
  fragment Concept on Concept {
    benefits
    brand {
      name
      url
    }
    categories {
      taxonomyId
    }
    description
    name
    products {
      ...Shade
    }
    ratingAverage
    ratingCount
  }
`;

const product = gql`
  ${concept}
  ${shade}
  fragment Product on Product {
    productCode
    concept {
      ...Concept
    }
  }
`;

const replacement = gql`
  fragment Replacement on ProductReplacement {
    product {
      ...Product
    }
  }
`;

const productWithReplacements = gql`
  ${product}
  ${replacement}
  fragment ProductWithReplacements on Product {
    ...Product
    replacements {
      ...Replacement
    }
  }
`;

export const getProducts = gql`
  ${productWithReplacements}
  query GetProducts($productCodes: [ID]) {
    products(productCodes: $productCodes) {
      ...ProductWithReplacements
    }
  }
`;
